module.exports = __webpack_public_path__ + "img/conny-stage1.9a6ca42f.png";